import { MessageCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCompanySettings } from "@/context/SettingsContext";
import { waLink } from "@/lib/constants";

const INTERNAL_ROLES = ["recruiter", "admin", "super_admin"];

/** Floating live chat: opens WhatsApp directly. Number is admin-configurable
 * (Admin Settings -> Company Settings -> Support WhatsApp Number). Never hardcoded.
 * Shown only to public visitors and members — hidden for internal team
 * (recruiter/admin/super admin) so it doesn't interfere with their work. */
export const WhatsAppChatButton = () => {
  const { user } = useAuth();
  const { settings } = useCompanySettings();
  const number = settings.support_whatsapp_number;
  if (!number) return null;
  if (user && INTERNAL_ROLES.includes(user.role)) return null;
  return (
    <a
      href={`${waLink(number)}?text=${encodeURIComponent("Hi! I need help with Udhyog Tech.")}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-chat-button"
      aria-label="Need Help? Chat with Us on WhatsApp"
      className="fixed bottom-5 right-5 z-50 group flex items-center gap-2 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white shadow-[var(--shadow-md)] pl-3.5 pr-4 py-3 transition-transform hover:-translate-y-0.5 print:hidden"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="text-sm font-medium hidden sm:inline">Need Help? Chat with Us</span>
    </a>
  );
};
